import { Component, computed, effect, inject, input } from '@angular/core';
import { CrntButtonAlt } from '@essent/current-web-angular';
import { ImageFieldValue } from '@core/jss-models';
import {
  CoreJssProxyModule,
  LinkField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';
import { FieldService, GenericLinkDirective } from '@core/jss-utils';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { ContentSectionService } from '@core/content-section';
import { NgClass } from '@angular/common';
import { TrackLinkDirective } from '@analytics/events';

import { BackgroundPatternComponent } from './background-pattern/background-pattern.component';

@Component({
  selector: 'wl-text-image',
  standalone: true,
  imports: [
    CrntButtonAlt,
    CoreJssProxyModule,
    GenericLinkDirective,
    RichTextWrapperComponent,
    NgClass,
    BackgroundPatternComponent,
    TrackLinkDirective,
  ],
  templateUrl: './text-image.component.html',
  styleUrls: [
    './text-image.component.ed.scss',
    './text-image.component.essent.scss',
  ],
})
export class TextImageComponent {
  readonly #config = inject(ENVIRONMENT_CONFIG);
  readonly #fieldService = inject(FieldService);
  readonly contentSectionService = inject(ContentSectionService);

  readonly inverse = input<boolean>(false);

  readonly title = input.required<TextField>();
  readonly content = input.required<RichTextField>();
  readonly image = input.required<ImageFieldValue>();
  readonly primaryButton = input<LinkField>();
  readonly secondaryButton = input<LinkField>();
  readonly microcopy = input<TextField>();

  theme = 'Wit';

  constructor() {
    effect(() => {
      this.theme = this.contentSectionService?.theme() ?? 'Wit';
    });
  }

  readonly showContent = computed(() =>
    this.#fieldService.showTextField(this.content())
  );

  readonly showPrimaryButton = computed(() =>
    this.#fieldService.showLinkField(this.primaryButton())
  );

  readonly showSecondaryButton = computed(() =>
    this.#fieldService.showLinkField(this.secondaryButton())
  );

  readonly showMicrocopy = computed(() =>
    this.#fieldService.showTextField(this.microcopy())
  );

  readonly buttonsShouldBeInverted = computed(() => {
    const themeInternal = this.contentSectionService?.theme() ?? 'Wit';
    if (this.isEnergieDirect()) {
      return 'Donker' === themeInternal;
    }
    return ['Merk', 'Donker'].includes(themeInternal);
  });

  readonly isEnergieDirect = computed(() => this.#config.brand === 'ed');
}
